export { default } from "./attach";
